"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
/**
 * This is a generic error page component that can be reused for multiple
 * different types of errors. The most common use case will likely be for
 * the 404 Error page, so some values will be defaulted.
 */
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var __1 = require("..");
var styled = styled_1.default;
var Page = function () {
    return styled.div(function (_a) {
        var theme = _a.theme;
        return "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: ".concat(theme.space.space8, ";\n    min-height: 100vh;\n    background-color: ").concat(theme.colors.surface100, ";\n    @media (min-width: ").concat(__1.screenSizes.medium, ") {\n        padding: ").concat(theme.space.space20, ";\n    }\n    ");
    });
};
var Wrapper = function (errorImageUrl) { return styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: ", ";\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  a {\n    text-decoration: none;\n  }\n  @media (min-width: ", ") {\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: right;\n    flex-direction: row;\n  }\n"], ["\n  width: 100%;\n  max-width: ", ";\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  a {\n    text-decoration: none;\n  }\n  @media (min-width: ", ") {\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: right;\n    flex-direction: row;\n  }\n"])), __1.screenSizes.large, __1.screenSizes.medium, errorImageUrl); };
var ErrorSummary = styled.h1(function (_a) {
    var theme = _a.theme;
    return "\n    font-size: 50px;\n    color: ".concat(theme.colors.contentPrimary, ";\n    font-weight: ").concat(theme.fontWeights.regular, ";\n    margin: 0;\n    @media (min-width: ").concat(__1.screenSizes.medium, ") {\n        font-size: 64px;\n    }\n    ");
});
var ErrorMessage = styled.p(function (_a) {
    var theme = _a.theme;
    return "\n    color: ".concat(theme.colors.contentPrimary, ";\n    font-size: ").concat(theme.fontSizes.fontsize16, "px;\n    line-height: 1.5;\n    margin: 14px 0 30px;\n    ");
});
var TextColumn = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  @media (min-width: ", ") {\n    text-align: left;\n  }\n"], ["\n  text-align: center;\n  @media (min-width: ", ") {\n    text-align: left;\n  }\n"])), __1.screenSizes.medium);
var Actions = styled.div(function (_a) {
    var theme = _a.theme;
    return "\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    > :not(:last-child) {\n        margin-right: ".concat(theme.space.space16, ";\n    }\n    @media (min-width: ").concat(__1.screenSizes.medium, ") {\n        justify-content: start;\n    }\n    ");
});
var Image = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  @media (min-width: ", ") {\n    display: none;\n  }\n"], ["\n  width: 100%;\n  @media (min-width: ", ") {\n    display: none;\n  }\n"])), __1.screenSizes.medium);
var ErrorPage = function (_a) {
    var onActionClick = _a.onActionClick, _b = _a.actionButtonContents, actionButtonContents = _b === void 0 ? function (theme) { return (React.createElement(React.Fragment, null,
        React.createElement(__1.BackIcon, { size: theme.space.space16 }),
        " ",
        React.createElement("span", null, "Go Back"))); } : _b, _c = _a.isEnterprise, isEnterprise = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? {
        summary: 'Page Not Found',
        message: "We can't find what you're looking for, but the links below may get you back on track",
    } : _d, fgImageUrl = _a.fgImageUrl;
    var theme = (0, __1.useCompassTheme)();
    var PageWrapper = Page();
    var InnerWrapper = Wrapper(fgImageUrl);
    var homeButtonHref = isEnterprise ? '/' : 'https://app.circleci.com/home';
    var homeButtonText = isEnterprise ? 'Go to Dashboard' : 'Go to Homepage';
    var buildErrorMessage = function () {
        if (typeof error.message === 'string') {
            return React.createElement(ErrorMessage, null, error.message);
        }
        else if (Array.isArray(error.message)) {
            return (React.createElement(React.Fragment, null, error.message.map(function (msg, index) { return (React.createElement(ErrorMessage, { key: "ErrorMessage-".concat(index) }, msg)); })));
        }
        else {
            // Is a function component already with its own styling and is defined
            return React.createElement(error.message, null);
        }
    };
    return (React.createElement(PageWrapper, null,
        React.createElement(InnerWrapper, null,
            React.createElement(TextColumn, null,
                React.createElement(ErrorSummary, null, error.summary),
                buildErrorMessage(),
                React.createElement(Actions, null,
                    onActionClick && (React.createElement(__1.SecondaryButton, { onPress: onActionClick }, actionButtonContents(theme))),
                    React.createElement(__1.SecondaryButtonLink, { href: homeButtonHref }, homeButtonText))),
            React.createElement(Image, { src: fgImageUrl }))));
};
exports.ErrorPage = ErrorPage;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map